module.exports = __webpack_public_path__ + "img/ambassador-page-header.9504fc59.svg";